import { EMPTY_EFFECTIVE_ACCESS_CONTROL } from "../../access-control/models/role-feature.models";
import { getCurrentUserAccessOrEmpty } from "../../access-control/services/access-control.service";
import { log, logE } from "../../shared/services/debug-logger";
import { DxoUSerOktaToken, OktaAccessToken } from "../models/DxoUserModel";
import { oktaAuth } from "./oktaAuth";
import { jwtDecode } from "jwt-decode";

const EMTPY_USER: DxoUSerOktaToken = {
  accessToken: {} as OktaAccessToken,
  accessTokenRaw: "",
  accessControl: EMPTY_EFFECTIVE_ACCESS_CONTROL,
};

// TODO Move to service
export async function getDxoUserAndToken(): Promise<DxoUSerOktaToken> {
  log("SERV - getDxoUserAndToken");
  const accessTokenRaw = oktaAuth.getAccessToken() || "";
  const accessToken = jwtDecode(accessTokenRaw) as OktaAccessToken;

  if (!accessToken) {
    logE(new Error("SERV - getDxoUserAndToken - token unavailable"));
    return EMTPY_USER;
  }

  const accessControl = await getCurrentUserAccessOrEmpty();
  log("SERV - getDxoUserAndToken - access resolved");

  return { accessToken, accessTokenRaw, accessControl };

  // TODO Separate method
  // TODO Check why DXO does not work for smartcube
  // try {
  //   const res = await fetch(
  //     process.env.REACT_APP_DXO_ME_ENDPOINT ?? '',
  //     {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${accessTokenRaw}`,
  //       },
  //     }
  //   );
  //   const dxoUser = (await res.json()) as DxoUser;

  //   return {dxoUser, accessToken, accessTokenRaw};
  // } catch (err) {
  //   console.error(err);
  // }

  // return EMTPY_USER;
}
